<template>
    <div class="creatAccount">
        <div class="icon">
            <i class="el-icon-circle-close-outline"></i>
        </div>
        <p>{{$store.state.msg}}</p>
        <div class="btn clearfix">
            <el-button class="f_r" @click="link">Go start</el-button>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        backBtn: Boolean
    },
    data(){
        return{
            activateInfo:{},
            rule:{}
        }
    },
    methods:{
        link(){
            this.$router.push({name:'home'})
        }
    }
}
</script>
<style lang="less" scoped>
h2{
    font-size: .28rem;
    font-weight: normal;
    margin-bottom: 0.17rem;
}
p{
    font-size: .16rem;
    margin-bottom: 0.30rem;
    a{
        color: #1EC345;
    }
}
.icon{
    text-align: center;
    margin-bottom: .30rem;
    font-size: .6rem;
    color: #999;
}
.btn{
    position: relative;
    a{
        color: #1EC345;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
    margin-bottom: .6rem;
}
@media(max-width:1024px){
    h2{
        font-size: .16rem;
        margin-bottom: .1rem;
    }
    p{
        font-size: .12rem;
        margin-bottom: 0.2rem;
    }
}
</style>

